import React, { useState, useContext, useRef, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { AuthContext } from '../../../../Header/auth - context';
import './PromenaLozinke.css';

const emptyForm = { currentPassword: '', username: '', newPin: '', confirmPin: '' };

const MobilnaAplikacija = () => {
    const { t } = useTranslation();
    const auth = useContext(AuthContext);
    const toast = useRef(null);

    const [status, setStatus]       = useState(null); // { postoji, username, upareno, last_login } | null (loading)
    const [showForm, setShowForm]   = useState(false);
    const [formData, setFormData]   = useState(emptyForm);
    const [show, setShow]           = useState({ currentPassword: false, newPin: false, confirmPin: false });
    const [prikaziPin, setPrikaziPin] = useState(false);
    const [saving, setSaving]       = useState(false);

    const fetchStatus = () => {
        fetch(process.env.REACT_APP_BACKEND_URL + '/mobile-operators/mojPristup', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
        })
            .then(r => { if (r.ok) return r.json(); throw r; })
            .then(data => setStatus(data))
            .catch(() => setStatus({ postoji: false }));
    };

    useEffect(() => { fetchStatus(); }, []); // eslint-disable-line

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: name === 'newPin' || name === 'confirmPin' ? value.replace(/\D/g, '') : value }));
    };
    const toggleShow = (field) => setShow(prev => ({ ...prev, [field]: !prev[field] }));

    const openForm = () => {
        setFormData({ ...emptyForm, username: status?.username || '' });
        setShowForm(true);
    };

    const pinMismatch = formData.confirmPin.length > 0 && formData.newPin !== formData.confirmPin;

    const submitReset = () => {
        setSaving(true);
        fetch(process.env.REACT_APP_BACKEND_URL + '/mobile-operators/mojPristup/reset', {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
            body: JSON.stringify({ currentPassword: formData.currentPassword, username: formData.username, newPin: formData.newPin }),
        })
            .then((response) => { if (response.ok) return response.json(); throw response; })
            .then((data) => {
                toast.current.show({ severity: 'success', summary: t('admin.m_uspesno'), detail: data.message, life: 4000 });
                setFormData(emptyForm);
                setShowForm(false);
                fetchStatus();
            })
            .catch((error) => {
                if (error.json) error.json().then((m) => toast.current.show({ severity: 'error', summary: t('admin.m_greska'), detail: m.message, life: 3000 }));
                else toast.current.show({ severity: 'error', summary: t('admin.m_greska'), detail: t('admin.m_greska_na_serveru'), life: 3000 });
            })
            .finally(() => setSaving(false));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.currentPassword || !formData.username || !formData.newPin || !formData.confirmPin) {
            toast.current.show({ severity: 'warn', summary: t('admin.m_upozorenje'), detail: t('admin.m_popuni_sva_obavezna_polja'), life: 3000 });
            return;
        }
        if (!/^\d{4}$/.test(formData.newPin)) {
            toast.current.show({ severity: 'warn', summary: t('admin.m_upozorenje'), detail: t('admin.mobPristupPinFormat'), life: 3000 });
            return;
        }
        if (formData.newPin !== formData.confirmPin) {
            toast.current.show({ severity: 'warn', summary: t('admin.m_upozorenje'), detail: t('korisnik.mobPinSeNePoklapaju'), life: 3000 });
            return;
        }
        confirmDialog({
            message: status?.postoji ? t('korisnik.mobPotvrdaReset') : t('korisnik.mobPotvrdaOmoguci'),
            header: t('korisnik.mobilnaAplikacija'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: t('common.da'),
            rejectLabel: t('common.ne'),
            accept: submitReset,
        });
    };

    const fieldWrap = { display: 'flex', flexDirection: 'column', gap: '0.35rem' };
    const labelStyle = { fontWeight: 600, fontSize: '0.9rem' };

    const renderField = (field, label, type, invalid) => (
        <div style={fieldWrap}>
            <label htmlFor={field} style={labelStyle}>{label}</label>
            {type === 'text' ? (
                <InputText id={field} name={field} value={formData[field]} onChange={handleChange} placeholder={label} />
            ) : (
                <div className="pw-row">
                    <InputText
                        id={field} name={field}
                        type={show[field] ? 'text' : type}
                        value={formData[field]}
                        maxLength={field.includes('Pin') ? 4 : undefined}
                        onChange={handleChange}
                        placeholder={label}
                        className={invalid ? 'p-invalid' : ''}
                        style={{ flex: 1, minWidth: 0 }}
                    />
                    <button type="button" className="pw-eye-btn" onClick={() => toggleShow(field)}
                        aria-label={show[field] ? 'Sakrij' : 'Prikaži'} title={show[field] ? 'Sakrij' : 'Prikaži'}>
                        <i className={`pi ${show[field] ? 'pi-eye-slash' : 'pi-eye'}`} />
                    </button>
                </div>
            )}
        </div>
    );

    const formatVreme = (v) => v ? new Date(v).toLocaleString('sr-RS', {
        day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Belgrade',
    }).replace(',', '') : t('korisnik.mobNikad');

    return (
        <div className="col-12">
            <Toast ref={toast} />
            <ConfirmDialog />
            <div style={{ maxWidth: 460, margin: '1.8rem auto 0', padding: '0 12px' }}>
                <Card>
                    <div style={{ textAlign: 'center', marginBottom: '1.4rem' }}>
                        <span style={{ display: 'inline-flex', width: 54, height: 54, borderRadius: '50%', background: 'rgba(109,109,19,0.12)', alignItems: 'center', justifyContent: 'center' }}>
                            <i className="pi pi-mobile" style={{ fontSize: '1.6rem', color: '#6d6d13' }} />
                        </span>
                        <h3 style={{ margin: '10px 0 2px', fontWeight: 700 }}>{t('korisnik.mobilnaAplikacija')}</h3>
                        <p style={{ margin: 0, color: 'var(--text-muted, #888)', fontSize: '0.82rem' }}>{t('korisnik.mobHelper')}</p>
                    </div>

                    {status === null ? (
                        <div style={{ textAlign: 'center', padding: '1rem 0', color: '#888' }}>{t('korisnik.mobUcitavanje')}</div>
                    ) : !showForm ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.9rem' }}>
                            {status.postoji ? (
                                <>
                                    <div className="mob-status-row">
                                        <span>{t('admin.mobOpUsername')}</span>
                                        <strong>{status.username}</strong>
                                    </div>
                                    <div className="mob-status-row">
                                        <span>{t('admin.mobOpPin')}</span>
                                        {status.pin ? (
                                            <strong style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                                                <span style={{ fontFamily: 'monospace', letterSpacing: '0.1em' }}>
                                                    {prikaziPin ? status.pin : '••••'}
                                                </span>
                                                <Button
                                                    type="button"
                                                    icon={`pi ${prikaziPin ? 'pi-eye-slash' : 'pi-eye'}`}
                                                    className="p-button-text p-button-sm"
                                                    onClick={() => setPrikaziPin((p) => !p)}
                                                />
                                            </strong>
                                        ) : (
                                            /* Nalozi od pre uvođenja pin_enc nemaju čitljiv PIN —
                                               bcrypt hash se ne može odvrnuti, pa se tek reset vidi. */
                                            <strong title={t('admin.mobOpPinNedostupan')} style={{ color: '#888' }}>—</strong>
                                        )}
                                    </div>
                                    <div className="mob-status-row">
                                        <span>{t('admin.mobOpUredjajUpareno')}</span>
                                        <strong style={{ color: status.upareno == 1 ? 'green' : '#888' }}>
                                            {status.upareno == 1 ? t('common.da') : t('common.ne')}
                                        </strong>
                                    </div>
                                    <div className="mob-status-row">
                                        <span>{t('korisnik.mobPoslednjaPrijava')}</span>
                                        <strong>{formatVreme(status.last_login)}</strong>
                                    </div>
                                </>
                            ) : (
                                <p style={{ textAlign: 'center', color: '#888', fontSize: '0.88rem' }}>{t('korisnik.mobNemaPristupa')}</p>
                            )}
                            <Button
                                label={status.postoji ? t('korisnik.mobResetujPin') : t('korisnik.mobOmoguciPristup')}
                                icon="pi pi-key"
                                className="p-button-warning"
                                style={{ width: '100%' }}
                                onClick={openForm}
                            />
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.1rem' }}>
                            <p style={{ margin: 0, fontSize: '0.82rem', color: '#b45309', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, padding: '8px 10px' }}>
                                <i className="pi pi-info-circle" style={{ marginRight: 6 }} />
                                {t('korisnik.mobResetNapomena')}
                            </p>
                            {renderField('currentPassword', t('admin.trenutnaLozinka'), 'password')}
                            {renderField('username', t('admin.mobOpUsername'), 'text')}
                            {renderField('newPin', t('korisnik.mobNoviPin'), 'password')}
                            <div>
                                {renderField('confirmPin', t('korisnik.mobPotvrdiPin'), 'password', pinMismatch)}
                                {pinMismatch && <small style={{ color: '#e53935' }}>{t('korisnik.mobPinSeNePoklapaju')}</small>}
                            </div>
                            <div className="fakture-stavke-radnje">
                                <Button type="button" label={t('common.ne')} className="p-button-outlined" style={{ flex: 1 }} onClick={() => setShowForm(false)} />
                                <Button type="submit" label={t('admin.sacuvaj')} icon="pi pi-check" loading={saving} className="p-button-success" style={{ flex: 1 }} />
                            </div>
                        </form>
                    )}
                </Card>
            </div>
        </div>
    );
};

export default MobilnaAplikacija;
